{
  "version": 1,
  "asset_id": "d030eb48-d926-44bc-a237-8d12e4b1bf49",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/d030eb48-d926-44bc-a237-8d12e4b1bf49/destination-roofing-tan-standing-seam-metal-roof-pine-ridge-fl-1200w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/d030eb48-d926-44bc-a237-8d12e4b1bf49/destination-roofing-tan-standing-seam-metal-roof-pine-ridge-fl-1200w.webp",
  "original_filename": "destination-roofing-tan-standing-seam-metal-roof-pine-ridge-fl-1200w.webp",
  "size": 95058,
  "content_type": "image/webp",
  "created_at": "2026-07-16T20:37:53Z"
}
